// Filters the search form derives from a UI-only toggle are removed by
// clearing the toggle, plus any value the toggle left in the form.
const FORM_PATHS_BY_FILTER_PATH = {
  "_item.exported": ["exported"],
  balanceAmount: ["unpaid", "balanceAmount"],
};

// Pure: the form-value removals that take a synopsis term out of the search.
const toInvoiceFormRemovals = removal =>
  FORM_PATHS_BY_FILTER_PATH[removal?.path]?.map(path => ({ path })) ?? [
    removal,
  ];

export { toInvoiceFormRemovals };
